import Box from "@/components/Box";
import StripeConnectSetupPanel from "@/components/organisations/business/ui/StripeConnectSetupPanel";
import Danger from "@/images/Danger";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";

export default function LinkYourBankAccount() {
  return (
    <Box px={[40]} pb={80}>
      <Stack
        alignItems={["flex-start", "flex-start", "center"]}
        maxWidth={760}
        stacked
        mx="auto"
        gap={[20, 20, 40]}
      >
        <Group alignItems="center" gap={[10, 10, 20]}>
          <Danger size={[22, 22, 40]} />
          <Box as="h2" fontFamily="gilroyBold" fontSize={[24, 24, 44]}>
            Link your bank account
          </Box>
        </Group>
        <StripeConnectSetupPanel.Body />
      </Stack>
    </Box>
  );
}
